module.exports = __webpack_public_path__ + "img/76131.82dd9bac.svg";